import Apple from "./svg/brand/apple.svg";
import Discord from "./svg/brand/discord.svg";
import Facebook from "./svg/brand/facebook.svg";
import Github from "./svg/brand/github.svg";
import Google from "./svg/brand/google.svg";
import Linkedin from "./svg/brand/linkedin.svg";
import AndroidStroke from "./svg/brand/stroke/android.svg";
import AppleStroke from "./svg/brand/stroke/apple.svg";
import ChromeStroke from "./svg/brand/stroke/chrome.svg";
import EdgeStroke from "./svg/brand/stroke/edge.svg";
import FirefoxStroke from "./svg/brand/stroke/firefox.svg";
import Twitter from "./svg/brand/twitter.svg";
import Spain from "./svg/flag/spain.svg";
import UnitedKingdom from "./svg/flag/united-kingdom.svg";
import LogoText from "./svg/logo-text.svg";
import Logo from "./svg/logo.svg";

export const Icons = {
  Logo,
  LogoText,
  Google,
  Github,
  Twitter,
  Apple,
  Facebook,
  AppleStroke,
  AndroidStroke,
  ChromeStroke,
  EdgeStroke,
  FirefoxStroke,
  Linkedin,
  Discord,
  UnitedKingdom,
  Spain,
} as const;
